<template>
  <div class="flex">
    <span
      v-if="loading"
      class="w-3 h-3 mr-2 border-4 border-solid small-spinner-animation"
    ></span>
    <div v-if="!loading" class="mr-2">
      <img
        v-if="isImage"
        @click="showPreview = true"
        class="object-fill w-8 h-8"
        :src="fileUrl"
      />
      <a
        class="text-white hover:text-highlight"
        v-if="!isImage"
        :href="fileUrl"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-10 h-10"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      </a>
    </div>
    <modal v-if="showPreview" type="preview" @close="showPreview = false">
      <template slot="body" class="h-auto max-w-3/4">
        <div
          style="max-width: 800px; max-height: 600px"
          class="relative flex justify-center"
        >
          <img class="block object-contain" :src="fileUrl" alt="label" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { isImage } from "../utils/imageHelpers";
import Modal from "./Modal.vue";
export default {
  components: { Modal },
  props: {
    folderName: { type: String },
    fileName: { type: String },
  },
  data() {
    return {
      loading: false,
      fileUrl: "",
      showPreview: false,
    };
  },
  methods: {
    async getFileUrl() {
      this.loading = true;

      const urlKey = `${this.folderName}/${this.fileName}`;

      const value = this.$store.getters["MEDIA_LIBRARY/URL"](urlKey);

      if (value) {
        this.fileUrl = value.url;
      } else {
        const { data } = await this.$store.$api.get(
          `/api/medialibrary/folders/${this.folderName}/files/${this.fileName}`
        );
        this.fileUrl = data && data.data;

        this.$store.dispatch("MEDIA_LIBRARY/SET_FILE_URL", {
          key: urlKey,
          url: this.fileUrl,
        });
      }

      this.loading = false;
    },
  },
  mounted() {
    this.getFileUrl();
  },
  computed: {
    isImage() {
      return isImage(this.fileName);
    },
  },
};
</script>

<style scoped>
.small-spinner-animation {
  border-color: rgba(255, 255, 255, 0.25);
  border-top-color: rgba(255, 255, 255, 1);
  border-radius: 50%;
  animation: smallSpinnerRotation 0.6s infinite linear;
}

@keyframes smallSpinnerRotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
